import ellipse from '../../assets/docchat/ellipse.svg';
import AppCarousel from '../AppCarousel/AppCarousel';
import AppDocumentProcessingBox from '../AppDocumentProcessingBox/AppDocumentProcessingBox';
import InlineStyled from '../InlineStyled/InlineStyled';

const docChatData = [
  {
    heading: 'Works with Word and PDF, including scanned PDFs',
    description:
      'Upload up to 50 Word files, PDFs or scanned PDFs. Mike DocChat reads across formats.',
  },
  {
    heading: 'Briefs in Seconds',
    description:
      'Summarize long contracts, court orders and other legal documents into clear, structured legal briefs instantly.',
  },
  {
    heading: 'Extract Key Terms',
    description:
      'Extract any information across contracts from obligations, deliverables, rights, favourable terms, exceptions & carve-outs, amounts, deadlines, payment terms and more.',
  },
  {
    heading: 'Workflows',
    description:
      'Extracts key data from documents using your custom or ready-made workflows, then exports to Excel.',
  },
];

const docCompareData = [
  {
    heading: 'Compares Across Formats',
    description:
      'Compare 2 to 6 Word files or PDFs, including scanned PDFs. Mike DocCompare works seamlessly across document formats.',
  },
  {
    heading: 'Context Comparison',
    description:
      'Detect “contextual deviations” across documents and within, beyond just simple additions or deletions.',
  },
  {
    heading: 'Clause Level Deviations',
    description:
      'Identify missing, modified or inconsistent clauses across versions with clear, clause-level comparison.',
  },
  {
    heading: 'Export & Review',
    description: 'Export deviations to Excel for easy review, tracking and sharing with your team.',
  },
];

const DashboardLoader = ({ product }) => {
  return (
    <InlineStyled
      style={{
        flex: 1,
        paddingTop: '120px',
        backgroundImage: `url("${ellipse}")`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50%',
      }}
    >
      <InlineStyled className='text-center'>
        <AppDocumentProcessingBox />
        <InlineStyled as='h1' style={{ fontSize: '28px', marginBottom: '30px' }}>
          What {product === 'docchat' ? 'DocChat' : 'DocCompare'}
          <span className='color-primary'> Can Do!</span>
        </InlineStyled>
        <InlineStyled style={{ maxWidth: '700px', margin: 'auto' }}>
          <AppCarousel>
            {(product === 'docchat' ? docChatData : docCompareData).map(
              ({ heading, description }) => (
                <InlineStyled $style={{ textAlign: 'center' }} key={heading}>
                  <InlineStyled
                    $style={{
                      color: '#465364',
                      fontSize: 18,
                      fontWeight: 600,
                      lineHeight: 'normal',
                      marginBottom: 16,
                    }}
                  >
                    {heading}
                  </InlineStyled>
                  <InlineStyled
                    $style={{
                      color: '#465364',
                      fontSize: 14,
                      fontWeight: 400,
                      lineHeight: 'normal',
                    }}
                  >
                    {description}
                  </InlineStyled>
                </InlineStyled>
              )
            )}
          </AppCarousel>
        </InlineStyled>
      </InlineStyled>
    </InlineStyled>
  );
};

export default DashboardLoader;
